// extracted by mini-css-extract-plugin
export var chip = "_56-0";
export var filterDropdown = "_56-5";
export var filterItem = "_56-6";
export var icon = "_56-1";
export var removeButton = "_56-3";
export var removeIcon = "_56-4";
export var separator = "_56-2";